import { extendTheme, withDefaultColorScheme } from "@chakra-ui/react";
import { colors } from "./colors";
import { components } from "./components";
import * as foundations from "./foundations";

export * from "./colors";
export * from "./sizes";

const space = {
  "4.5": "1.125rem",
  "22": "5.5rem",
};

const theme = {
  ...foundations,
  colors,
  components,
  sizes: space,
  space,
};

const defaultColorScheme = {
  colorScheme: "brand",
  components: ["Checkbox"],
};

export const customTheme = extendTheme(
  theme,
  withDefaultColorScheme(defaultColorScheme),
);

// Need to export as default for chakra-cli to pick up theme
// eslint-disable-next-line import/no-default-export
export default customTheme;
